import React, { useState } from 'react';
import classNames from 'classnames';
import Tab from './components/tab';

const TabSelector = ({
  activeTabId = undefined,
  defaultActiveTabId = undefined,
  tabs,
  size = 'medium',
  onClick,
}) => {
  const classes = classNames('ws-ui-tab-selector', `ws-ui-tab-selector--${size}`);

  if (defaultActiveTabId !== undefined && activeTabId !== undefined) {
    throw new Error(`
      TabSelector component can be either controlled, or uncontrolled.
      If you want it to be controlled - please pass the 'activeTabId',
      and update it externally via the 'onClick' callback.
      If you want it to be uncontrolled - please pass the 'defaultActiveTabId',
      and its updates will be handled by the component itself.
    `);
  }

  const [uncontrolledActiveTabId, setUncontrolledActiveTabId] = useState(defaultActiveTabId);

  const selectedId = activeTabId ?? uncontrolledActiveTabId;

  const handleClick = (tabId) => {
    setUncontrolledActiveTabId(tabId);
    onClick(tabId);
  };

  return (
    <div className={classes}>
      {tabs.map(({ id, label, disabled }) => (
        <Tab
          key={id}
          label={label}
          selected={id === selectedId}
          disabled={disabled}
          onClick={() => {
            handleClick(id);
          }}
        />
      ))}
    </div>
  );
};

export default TabSelector;
